export const joinClassnames = (classes: string[]) => {
  return classes.filter(Boolean).join(' ')
}
